import React from 'react';
import { Button, Flex } from '@mantine/core';

interface SaveAndCloseProps {
  setIsManagingFilters: React.Dispatch<React.SetStateAction<boolean>>;
  editFilters: () => void;
}

const SaveAndClose: React.FC<SaveAndCloseProps> = ({ setIsManagingFilters, editFilters }) => {
  return (
    <Flex
      w='41%' 
      justify='space-evenly'
      px={16}
      pb={10} 
    >
      <Button
        variant='default'
        onClick={() => setIsManagingFilters(false)}
      >
        Cancel
      </Button>
      <Button
        onClick={editFilters}
        color='indigo'
      >
        Save   
      </Button>
    </Flex>
  )
}

export default SaveAndClose